import { Link, usePage } from '@inertiajs/react'
import { Code2 } from 'lucide-react'
import { Card, CardContent } from '@/components/ui/Card'
import { Button } from '@/components/ui/Button'
import { useRouteParams } from '@/hooks/useRoutes'
import routes from '@/routeHelpers'
import missingConfigImage from '@/assets/images/missing_config.png'

interface WidgetSetupPromptProps {
  variant?: 'full' | 'compact'
  className?: string
}

export function WidgetSetupPrompt({ variant = 'full', className }: WidgetSetupPromptProps) {
  const { withAccount } = useRouteParams()
  const widgetSettingsUrl = `${routes.settings.show.path(withAccount())}?tab=widget`

  if (variant === 'compact') {
    return (
      <Card glow className={className}>
        <CardContent className="p-4">
          <Link href={widgetSettingsUrl} className="flex flex-col items-center text-center cursor-pointer group">
            <img src={missingConfigImage} alt="" className="size-20 mb-3" />
            <p className="text-sm font-medium group-hover:text-primary transition-colors">It's too quiet!</p>
            <p className="text-xs text-muted-foreground">Set up your widget to start hearing screams</p>
          </Link>
        </CardContent>
      </Card>
    )
  }

  return (
    <div className={`flex flex-col items-center justify-center text-center ${className ?? ''}`}>
      <img src={missingConfigImage} alt="" className="size-32 mb-6" />
      <h3 className="text-lg font-medium mb-2">It's too quiet in here!</h3>
      <p className="text-muted-foreground max-w-md mb-6">
        Add a few lines of code to your website and start hearing the screams of your visitors.
      </p>
      <Button asChild className="cursor-pointer">
        <Link href={widgetSettingsUrl}>
          <Code2 className="size-4 mr-2" />
          Set up widget
        </Link>
      </Button>
    </div>
  )
}

export function useWidgetConfigured(): boolean {
  const { props } = usePage<{ widget_configured: boolean }>()
  return props.widget_configured ?? false
}
